import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import CtaPanel from '../components/CtaPanel';
import { masterBrands, additionalBrands, brands } from '../data/brands';
import './Partners.css';

function PartnerCards({ list, master }) {
  return (
    <div className="partner-cards">
      {list.map((partner) => (
        <article className="partner-card" key={partner.id} id={partner.id}>
          <div className="partner-card-logo">
            <img src={partner.logo} alt={`${partner.name} logo`} loading="lazy" />
          </div>
          <div className="partner-card-body">
            <div className="partner-card-header">
              <h3>{partner.name}</h3>
              {master && <span className="partner-badge">Master distributor</span>}
            </div>
            <p className="partner-description">{partner.description}</p>
            <h4>Products we stock</h4>
            <div className="partner-product-tags">
              {partner.brandProducts.map((product) => (
                <span className="app-tag" key={product}>
                  {product}
                </span>
              ))}
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}

function Partners() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.slice(1);
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location.hash]);

  return (
    <div className="partners-page">
      <SEO />

      <PageHero
        breadcrumbs={[{ name: 'Partners', path: '/partners' }]}
        kicker="Our partners"
        bg="/images/bg-siniat.jpg"
        title="Master Distributor for SuperTec, ETEX, Siniat & OWA"
        text="We are proud to partner with leading manufacturers in the building industry. As master distributor for SuperTec, ETEX, Siniat and OWA, we bring you the best products backed by decades of manufacturing expertise."
      >
        <nav className="partners-jump" aria-label="Jump to a brand">
          {brands.map((brand) => (
            <a key={brand.id} href={`#${brand.id}`} className={location.hash === `#${brand.id}` ? 'active' : undefined}>
              {brand.shortName || brand.name}
            </a>
          ))}
        </nav>
      </PageHero>

      <section className="section section-white">
        <div className="container">
          <div className="section-head">
            <span className="pill">★ Master distributor for</span>
            <h2 className="section-title">Our primary brands</h2>
            <p className="section-subtitle">
              Official master distributor — full product range, technical support and competitive pricing
            </p>
          </div>
          <PartnerCards list={masterBrands} master />
        </div>
      </section>

      <section className="section section-light">
        <div className="container">
          <div className="section-head">
            <span className="pill">Also distributing products from</span>
            <h2 className="section-title">Additional brands</h2>
            <p className="section-subtitle">
              Quality products from other trusted manufacturers to complement our core range
            </p>
          </div>
          <PartnerCards list={additionalBrands} />
        </div>
      </section>

      <CtaPanel
        title="Need products from these brands?"
        text="Contact us for availability, pricing and expert advice on choosing the right products for your project."
      />
    </div>
  );
}

export default Partners;
